export const WindowBreakpoints = {
  xs: 320,        // Extra small devices
  sm: 480,        // Small devices
  md: 768,        // Medium devices
  lg: 1024,       // Large devices
  xl: 1440,       // Extra large devices
  xxl: 1920,       // Ultra wide screens
  xxxl: 2200       // Ultra wide screens
}
